<!-- <div class="container">
    <h2 class="head">KYC Details</h2>
    <div class="back-arrow" (click)="goBack()">
        <img class="backarrow-img" src="../../assets/back_arrow.png" alt="">
    </div>

    <div *ngIf="loading" class="text-center text-white">
        <div class="spinner-border text-light" role="status">
            <span class="visually-hidden">Loading...</span>
        </div>
        <p>Loading KYC details...</p>
    </div>


    <div *ngIf="!loading && error" class="text-center text-white">
        <p class="text-danger">{{ error }}</p>
        <button class="btn btn-primary" (click)="kycGet()">Retry</button>
    </div>


    <div *ngIf="!loading && !error && userKycDetails" class="first-sec">
        <div class="row">
            <div class="col-md-12">
                <div class="my-select-gold">
                    <p class="statusChange">KYC Status : 
                        <b class="labels">{{ getStatusMessage() }}</b>
                    </p>
                    <p colspan="2" class="text-white h3 text-center">Details : -</p>
                </div>
            </div>
            <div class="col-md-1"></div>
            <div class="col-md-5">
                <table class="table table-responsive tabele-bordered">
                    <tr>
                        <th class="my-select">Business Name</th>
                        <td class="my-select">:</td>
                        <td class="my-select">{{ getValue('data.business_name') }}</td>
                    </tr>
                    <tr>
                        <th class="my-select">Business Type</th>
                        <td class="my-select">:</td>
                        <td class="my-select">{{ getValue('data.business_type') }}</td>
                    </tr>
                    <tr>
                        <th class="my-select">Proprietor Name</th>
                        <td class="my-select">:</td>
                        <td class="my-select">{{ getValue('data.proprietor_name') }}</td>
                    </tr>
                    <tr>
                        <th class="my-select">Phone Number</th>
                        <td class="my-select">:</td>
                        <td class="my-select">{{ getValue('data.register_phone_number') }}</td>
                    </tr>
                    <tr>
                        <th class="my-select">Email</th>
                        <td class="my-select">:</td>
                        <td class="my-select">{{ getValue('data.email') }}</td>
                    </tr>
                </table>
            </div>
            <div class="col-md-5">
                <table class="table table-responsive">
                    <tr>
                        <th class="my-select">City</th>
                        <td class="my-select">:</td>
                        <td class="my-select">{{ getValue('data.city') }}</td>
                    </tr>
                    <tr>
                        <th class="my-select">State</th>
                        <td class="my-select">:</td>
                        <td class="my-select">{{ getValue('data.state') }}</td>
                    </tr>
                    <tr>
                        <th class="my-select">Pin Code</th>
                        <td class="my-select">:</td>
                        <td class="my-select">{{ getValue('data.pin_code') }}</td>
                    </tr>
                    <tr>
                        <th class="my-select">Bank Name</th>
                        <td class="my-select">:</td>
                        <td class="my-select">{{ getValue('data.bank_name') }}</td>
                    </tr>
                    <tr>
                        <th class="my-select">Account Number</th>
                        <td class="my-select">:</td>
                        <td class="my-select">{{ getValue('data.account_number') }}</td>
                    </tr>
                </table>
            </div>
            <div class="col-md-1"></div>
        </div>
    </div>

  
    <p class="text-white re-update" *ngIf="!loading && !error && userKycDetails && showUpdateLink">
        Please update your KYC again 
        <a routerLink="/update-kyc" class="text-red">Click Here</a>
    </p>


    <div *ngIf="!loading && !error && !userKycDetails" class="text-center text-white">
        <p>No KYC details found.</p>
    </div>
</div> -->


<div class="container kyc-wrap">

  <div class="top-bar">
    <div class="back-arrow" (click)="goBack()">
      <img class="backarrow-img" src="../../assets/back_arrow.png" alt="">
    </div>
    <h2 class="head">KYC Details</h2>
  </div>

  <!-- Loading State -->
  <div *ngIf="loading" class="state-box">
    <div class="spinner-border text-warning" role="status">
      <span class="visually-hidden">Loading...</span>
    </div>
    <p class="state-text">Loading KYC details...</p>
  </div>

  <!-- Error State -->
  <div *ngIf="!loading && error" class="state-box">
    <p class="state-text error-text">{{ error }}</p>
    <button class="my-button retry-btn" (click)="kycGet()">Retry</button>
  </div>

  <!-- KYC Details -->
  <div *ngIf="!loading && !error && userKycDetails" class="first-sec">

    <div class="status-card">
      <div class="status-left">
        <span class="status-icon">
          <i class="fa-solid fa-shield-halved"></i>
        </span>
        <p class="statusChange">KYC Status</p>
      </div>
      <span class="status-badge" [ngClass]="getStatusClass()">{{ getStatusMessage() }}</span>
    </div>

    <div class="section-title-wrap">
      <p class="section-title">Details</p>
      <span class="title-line"></span>
    </div>

    <div class="info-card">
      <div class="details-grid">

        <div class="info-column">
          <div class="info-row">
            <span class="info-label">Business Name</span>
            <span class="info-value">{{ getValue('data.business_name') }}</span>
          </div>
          <div class="info-row">
            <span class="info-label">Business Type</span>
            <span class="info-value">{{ getValue('data.business_type') }}</span>
          </div>
          <div class="info-row">
            <span class="info-label">Proprietor Name</span>
            <span class="info-value">{{ getValue('data.proprietor_name') }}</span>
          </div>
          <div class="info-row">
            <span class="info-label">Phone Number</span>
            <span class="info-value">{{ getValue('data.register_phone_number') }}</span>
          </div>
          <div class="info-row">
            <span class="info-label">Email</span>
            <span class="info-value">{{ getValue('data.email') }}</span>
          </div>
        </div>

        <div class="info-column">
          <div class="info-row">
            <span class="info-label">City</span>
            <span class="info-value">{{ getValue('data.city') }}</span>
          </div>
          <div class="info-row">
            <span class="info-label">State</span>
            <span class="info-value">{{ getValue('data.state') }}</span>
          </div>
          <div class="info-row">
            <span class="info-label">Pin Code</span>
            <span class="info-value">{{ getValue('data.pin_code') }}</span>
          </div>
          <div class="info-row">
            <span class="info-label">Bank Name</span>
            <span class="info-value">{{ getValue('data.bank_name') }}</span>
          </div>
          <div class="info-row">
            <span class="info-label">Account Number</span>
            <span class="info-value">{{ getValue('data.account_number') }}</span>
          </div>
        </div>

      </div>
    </div>

  </div>

  <!-- Update KYC Link -->
  <!-- <p class="re-update" *ngIf="!loading && !error && userKycDetails && showUpdateLink">
    Please update your KYC again
    <a routerLink="/update-kyc" class="text-red">Click Here</a>
  </p> -->


  <p class="re-update"
   *ngIf="!loading && !error && showUpdateLink">
  Please update your KYC again
  <a routerLink="/update-kyc" class="text-red">Click Here</a>
</p>

  <!-- No Data State -->
  <div *ngIf="!loading && !error && !userKycDetails" class="state-box">
    <p class="state-text">No KYC details found.</p>
  </div>

</div>